<template>
  <div class="challenge-section" id="the-challenge" :style="{ order: order }">
    <h2>{{ title }}</h2>
    <p v-if="showQuoteAuthor" class="quote-author">{{ quoteAuthor }}</p>
    <blockquote v-if="showQuote" class="quote" :style="{ backgroundColor: quoteBackgroundColor }">
      {{ quote }}
    </blockquote>
    <div v-for="(paragraph, index) in description" :key="index">
      <p class="description">{{ paragraph }}</p>
    </div>
    <ul class="roadblocks">
      <li v-for="(roadblock, index) in roadblocks" :key="index">
        <span v-if="getRoadblockTitle(roadblock)" class="roadblock-title">{{ getRoadblockTitle(roadblock) }}</span>
        <span :class="{ 'roadblock-description': !getRoadblockTitle(roadblock) }">{{ getRoadblockDescription(roadblock) }}</span>
      </li>
    </ul>
    <div v-if="showEndparagraphs" v-for="(endparagraph, index) in endparagraphs" :key="index">
      <p class="endparagraph mb-4">{{ endparagraph }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChallengeSection',
  props: {
    title: String,
    quote: String,
    quoteAuthor: String,
    description: Array,
    roadblocks: Array,
    endparagraphs: Array,
    showEndparagraphs: {
      type: Boolean,
      default: false,
    },
    quoteBackgroundColor: {
      type: String,
      default: '#faeaea',
    },
    order: {
      type: Number,
      default: 0,
    },
    showQuote: {
      type: Boolean,
      default: false,
    },
    showQuoteAuthor: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getRoadblockTitle(roadblock) {
      if (roadblock.startsWith(':')) {
        return ''; // No title if the string starts with a colon
      }
      const parts = roadblock.split(':');
      return parts[0] + ':';
    },
    getRoadblockDescription(roadblock) {
      if (roadblock.startsWith(':')) {
        return roadblock.slice(1).trim(); // Return everything after the colon
      }
      const parts = roadblock.split(':');
      return parts.length > 1 ? parts[1].trim() : '';
    },
  },
};
</script>

<style scoped>
.challenge-section {
  padding: 40px 0;
  text-align: left;
}

h2 {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #FF6860;
}

.quote-author {
  font-size: 16px;
  margin-bottom: 10px;
}

.quote {
  font-size: 18px;
  font-style: italic;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 20px;
  color: #FF6860;
}

.description {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
}

.roadblocks {
  list-style: none;
  padding: 0;
}

.roadblocks li {
  font-size: 16px;
  color: #333;
  margin-bottom: 15px;
  position: relative;
  padding-left: 20px;
  line-height: 1.5;
}

.roadblocks li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #333;
  font-size: 20px;
}

.roadblock-title {
  font-weight: bold;
}

.roadblock-description {
  font-weight: normal; /* Ensure description is not bold when no title */
}

@media (max-width: 768px) {
  h2 {
    font-size: 32px;
  }
}
</style>